import { Calendar, HandWaving, Television } from '@phosphor-icons/react'
import clsx from 'clsx'
import { motion } from 'motion/react'
import NextLink from 'next/link'
import React from 'react'

const Link = motion(NextLink as any)

export function GetInTouch() {
  return (
    <div className='mx-auto w-full gap-[80px] grid grid-rows-[auto] grid-cols-[1fr_1fr_1fr] auto-cols-[1fr] place-items-center pt-[100px] px-[80px] pb-[120px] max-w-[1280px] max-[768px]:gap-[40px] max-[768px]:grid-rows-[auto_auto_auto] max-[768px]:grid-cols-[1fr] max-[991px]:px-[56px]'>
      <Card
        icon={HandWaving}
        heading='Say hello'
        description='Drop us a line for support, partnership talks, or just to say Hi.'
        cta='Contact us'
        href='mailto:support@mapstack.io'
        slotProps={{
          Icon: {
            className: 'text-yellow-500'
          }
        }}
      />

      <Card
        icon={Calendar}
        heading='Book a demo'
        description='Let our specialists show you how to get the most value from Mapstack. Fast!'
        cta='Book a demo'
        href='https://calendar.app.google/AkthgoGQXzqRBTx66'
        slotProps={{
          Icon: {
            className: 'text-blue-500'
          }
        }}
      />

      <Card
        icon={Television}
        heading='Media'
        description='Interested in featuring Mapstack, we would love to hear from you!'
        cta='Get in touch'
        href='mailto:support@mapstack.io'
        slotProps={{
          Icon: {
            className: 'text-green-500'
          }
        }}
      />
    </div>
  )
}

function Card(props) {
  const Icon = props.icon || React.Fragment

  return (
    <div className='flex items-start self-stretch flex-col gap-[30px] max-[768px]:w-[70%]'>
      <div className='flex items-stretch self-auto justify-start flex-1 flex-col gap-[10px]'>
        <Icon
          className={clsx(
            'mb-[8px] relative w-[100px] h-[100px] flex items-start justify-start gap-[10px]',
            props.slotProps?.Icon?.className
          )}
          size={100}
          weight='duotone'
        />

        <h4 className='text-black text-[24px] font-[700] leading-[110%] mb-[16px] tracking-[-.02em]'>
          {props.heading}
        </h4>
        <p className='text-black text-[19px] font-[400] leading-[130%]'>
          {props.description}
        </p>
      </div>
      <Link
        className='border-[1px] border-solid border-brand-02 px-[24px] py-[16px] text-[17px] font-[500] leading-[100%] text-center text-brand-02 rounded-2xl hover:ring-1'
        href={props.href}
        whileHover={{
          scale: 1.1,
          transition: { duration: 0.3, ease: 'easeInOut' }
        }}
      >
        {props.cta}
      </Link>
    </div>
  )
}
